'use strict'

export default class InsertFontAwesomeIcons {
  constructor () {
    this.icons = {
      image: 'fa-file-image',
      pdf: 'fa-file-pdf',
      word: 'fa-file-word',
      powerpoint: 'fa-file-powerpoint',
      excel: 'fa-file-excel',
      audio: 'fa-file-audio',
      video: 'fa-file-video',
      zip: 'fa-file-archive',
      code: 'fa-file-code',
      text: 'fa-file-alt',
      file: 'fa-file'
    }

    this.extensions = {
      gif: this.icons.image,
      jpeg: this.icons.image,
      jpg: this.icons.image,
      png: this.icons.image,

      pdf: this.icons.pdf,

      doc: this.icons.word,
      docx: this.icons.word,

      ppt: this.icons.powerpoint,
      pptx: this.icons.powerpoint,

      xls: this.icons.excel,
      xlsx: this.icons.excel,

      aac: this.icons.audio,
      mp3: this.icons.audio,
      ogg: this.icons.audio,

      avi: this.icons.video,
      flv: this.icons.video,
      mkv: this.icons.video,
      mp4: this.icons.video,

      gz: this.icons.zip,
      zip: this.icons.zip,

      css: this.icons.code,
      html: this.icons.code,
      js: this.icons.code,

      txt: this.icons.text,

      file: this.icons.file
    }
  }

  enable () {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        const elements = Array.from(document.getElementsByClassName('file-extension-icon'))

        elements.forEach((item) => {
          item.classList.add(this._getClassNameForExtension(item.dataset.fileExtension))
        })
      }
    }

    return this
  }

  _getClassNameForExtension (extension) {
    let className = this.icons.file

    if (extension && extension !== '') {
      className = this.extensions[extension.toLowerCase()]
    }

    return className
  }
}
